import { List } from '@mui/material';
import identity from 'lodash.identity';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import benchmarkIconUrl from '../../../../../../assets/image/sidebarIcons/benchmark.png';
import forecastTypeIconUrl from '../../../../../../assets/image/sidebarIcons/forecastType.png';
import segmentIconUrl from '../../../../../../assets/image/sidebarIcons/segment.png';
import { useDashboardPageOptionsContext } from '../dashboards/contexts';
import { FilterMenuItem } from './FilterMenuItem';
import { SideBarListItem } from './SideBarListItem';
import { FilterState, IntercomArticleKeys, SegmentationState } from './types';

const FirstList = styled(List)`
  margin-top: 35px;
` as typeof List;

interface FilterAndMasterResetProps {
  setMenuOpen: (event: React.MouseEvent<HTMLElement>, name: string) => void;
  setFilterDrawerState: (value: FilterState) => void;
  setSegmentationLevel1DrawerState: (value: SegmentationState) => void;
}

export const SideBarTop = (props: FilterAndMasterResetProps) => {
  const { t } = useTranslation();
  const {
    setMenuOpen,
    setFilterDrawerState,
    setSegmentationLevel1DrawerState,
  } = props;
  const options = useDashboardPageOptionsContext();
  const showSegmentationLevel1 = options.segmentationLevel1?.enabled ?? true;
  const showSegmentationLevel2 = options.segmentationLevel2?.enabled ?? true;
  const showBenchmark = options.benchmark?.enabled ?? true;
  const showForecast = options.forecast?.enabled ?? true;
  return (
    <FirstList>
      <FilterMenuItem setDrawerState={setFilterDrawerState} />
      <SideBarListItem
        iconUrl={segmentIconUrl}
        text={t('common:dashboardSideBar.segmentLevel1')}
        disabled={!showSegmentationLevel1}
        className="intercom_sidebar_segmentLevel1"
        onClick={() => setSegmentationLevel1DrawerState('segmentation1')}
        key="segmentation1"
        data-cy="panalyt-dashboard-sidebar-segmentLevel1"
        intercomArticleKey={IntercomArticleKeys.SEGMENT}
      />
      <SideBarListItem
        iconUrl={segmentIconUrl}
        text={t('common:dashboardSideBar.segmentLevel2')}
        disabled={!showSegmentationLevel2}
        className="intercom_sidebar_segmentLevel2"
        onClick={identity}
        key="segmentation2"
        data-cy="panalyt-dashboard-sidebar-segmentLevel2"
        intercomArticleKey={IntercomArticleKeys.SEGMENT}
      />
      <SideBarListItem
        iconUrl={benchmarkIconUrl}
        disabled={!showBenchmark}
        text={t('common:dashboardSideBar.benchmarks')}
        onClick={(e) => setMenuOpen(e, 'benchmark')}
        className="intercom_sidebar_benchmark"
        key="benchmark"
        data-cy="panalyt-dashboard-sidebar-benchmarks"
        intercomArticleKey={IntercomArticleKeys.BENCHMARK}
      />
      <SideBarListItem
        iconUrl={forecastTypeIconUrl}
        text={t('common:dashboardSideBar.forecast')}
        onClick={(e) => setMenuOpen(e, 'forecast')}
        disabled={!showForecast}
        className="intercom_sidebar_forecastType"
        key="forecast"
        intercomArticleKey={IntercomArticleKeys.FORECAST}
      />
    </FirstList>
  );
};
